const DEFAULT_PAGE_SIZE = 25;

export function useLimitOffsetFromPage(page: number, pageSize?: number) {
  const size = pageSize ?? DEFAULT_PAGE_SIZE;
  return {
    limit: size,
    offset: (page - 1) * size,
  };
}
